import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Clock } from 'lucide-react';
export function OpeningHook() {
  return <div className="bg-cream text-navy" data-id="element-151">
      <SectionWrapper data-id="element-152">
        <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-153">
          <div className="flex justify-center mb-6" data-id="element-154">
            <div className="p-4 bg-navy/5 rounded-full text-gold" data-id="element-155">
              <Clock size={32} data-id="element-156" />
            </div>
          </div>

          <p className="text-xl md:text-2xl font-serif leading-relaxed italic text-navy-light" data-id="element-157">
            "Son las 2:15 AM. Estás sentada en la oscuridad, con el peso de tu
            bebé en los brazos y un nudo en el estómago. No es solo el
            agotamiento; es el miedo visceral a la reunión de las 8:00 AM."
          </p>

          <div className="w-16 h-px bg-gold mx-auto my-8" data-id="element-158"></div>

          <p className="text-lg md:text-xl font-sans text-navy/80 leading-relaxed" data-id="element-159">
            Sabes que mañana no serás la profesional brillante que todos
            conocen. Serás una sombra de ti misma, tratando de sobrevivir a base
            de café y neblina mental mientras ruegas que nadie note que apenas
            puedes articular una frase coherente.
          </p>
        </div>
      </SectionWrapper>
    </div>;
}